import ActionMenu from './ActionMenu.vue';

export default ActionMenu;
